<div class="progress-bar">
  <div [className]="value?.textClass ? value.textClass : ''">
    {{ value?.title }}
  </div>
  <div *ngIf="value?.isPercorrenza!==false" class="progress">
    <span [ngStyle]="getProgressStyle()"></span>
  </div>
  <div class="sub-text" [className]="value?.textClass ? value.textClass : ''">
    <span>{{ value?.subTextTitle }}</span>
    <span [ngStyle]="{ color: value?.color }">{{ value?.subTextValue }}</span>
  </div>
</div>
